import { useEffect, useState } from "react"
import { getAllCategories } from "../api/categoryApi";
import { SearchableSelect } from "./SearchableSelect";
import { X } from "lucide-react";

export const BarterForSelect = ({ value = [], onChange, error }) => {
    const [categories, setCategories] = useState([])
    const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState("");

   useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    setLoading(true);
    setFetchError("");

    try {
      const response = await getAllCategories();

      if (response.success) {
        setCategories(response.categories);
      } else {
        setFetchError("Failed to load categories");
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      setFetchError("Failed to load categories");
    } finally {
      setLoading(false);
    }
  };

   const handleCategoryAdd = (categoryId) => {
    const selectedCategory = categories.find(cat => cat._id === categoryId);
    
    if (selectedCategory && onChange) {
      // Check if category is already in the array
      const isAlreadyAdded = value.some(item => 
        (item._id || item) === selectedCategory._id
      );
      
      if (!isAlreadyAdded) {
        // Add the new category to the array
        onChange([...value, {
          _id: selectedCategory._id,
          name: selectedCategory.name
        }]);
      }
    }
  };

   const handleCategoryRemove = (categoryId) => {
    if (onChange) {
      // Remove the category from the array
      const updatedValue = value.filter(item => 
        (item._id || item) !== categoryId
      );
      onChange(updatedValue);
    }
  };

  // Filter out already selected categories from the dropdown
  const availableCategories = categories.filter(category => 
    !value.some(item => (item._id || item) === category._id)
  );

  return (
    <div className="space-y-3">
      {/* Selected Categories Display */}
      {value.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {value.map((item) => {
            const categoryName = item.name || item;
            const categoryId = item._id || item;
            
            return (
              <div
                key={categoryId}
                className="inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm"
              >
                <span>{categoryName}</span>
                <button
                  type="button"
                  onClick={() => handleCategoryRemove(categoryId)}
                  className="ml-1 hover:bg-blue-200 rounded-full p-0.5 transition-colors"
                  aria-label={`Remove ${categoryName}`}
                >
                  <X size={14} />
                </button>
              </div>
            );
          })}
        </div>
      )}

      {/* Category Selector */}
      <SearchableSelect
        options={availableCategories}
        value=""
        onValueChange={handleCategoryAdd}
        placeholder={
          availableCategories.length === 0 
            ? "All categories selected" 
            : "Select categories to barter for..."
        }
        searchPlaceholder="Search categories..."
        loading={loading}
        error={error || fetchError}
        formatOption={(category) => category.name}
        getValue={(category) => category._id}
        emptyMessage="No more categories available"
        disabled={availableCategories.length === 0}
      />

      {/* Helper text */}
      <p className="text-xs text-muted-foreground">
        Select multiple categories you'd be willing to barter for. You can remove items by clicking the × button.
      </p>
    </div>
  );
}